import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Alert,
    Card,
    CardBody,
    CardText,
    ListGroup,
    ListGroupItem,
    Spinner,
} from "reactstrap";
import { setUserToken } from "../../api/base";
import escolas, { EscolaSearchResponse } from "../../api/escolas";
import usuarios from "../../api/usuarios";
import { errorToString } from "../../helpers/funcoes";
import { Titulo } from "../Titulo";

export function EscolaSelecaoPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submittingId, setSubmittingId] = useState<string>();
  const [items, setItems] = useState<EscolaSearchResponse[]>([]);
  const [error, setError] = useState<string>();

  useEffect(() => {
    setLoading(true);
    setError(undefined);

    escolas
      .search()
      .then((res) => setItems(res.data))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setLoading(false));
  }, []);

  const onSelect = (escolaId: string) => {
    setSubmittingId(escolaId);
    setError(undefined);

    usuarios
      .refresh({ escolaId })
      .then((res) => {
        setUserToken(res.token);
        navigate("/", { replace: true });
      })
      .catch((err) => setError(errorToString(err)))
      .finally(() => setSubmittingId(undefined));
  };

  if (loading) {
    return (
      <div className="text-center" data-cy="school-selection-loading">
        <Spinner />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "720px", margin: "0 auto" }}>
      <Card>
        <CardBody>
          <Titulo text="Selecione a escola" />
          <CardText className="text-muted">
            Escolha qual escola será gerenciada nesta sessão.
          </CardText>
          {error && (
            <Alert color="danger" data-cy="school-selection-error">
              {error}
            </Alert>
          )}
          <ListGroup flush data-cy="school-selection-list">
            {items.map((item) => {
              const submitting = submittingId === item.id;

              return (
                <ListGroupItem
                  key={item.id}
                  tag="button"
                  action
                  disabled={!!submittingId}
                  className="d-flex justify-content-between align-items-center"
                  data-cy={`school-option-${item.id}`}
                  onClick={() => onSelect(item.id)}
                >
                  <span>{item.nome}</span>
                  {submitting && <Spinner size="sm" />}
                </ListGroupItem>
              );
            })}
          </ListGroup>
        </CardBody>
      </Card>
    </div>
  );
}